<template>
    <div class="sucOrdered">
        <div id="content">
            <div class="sucTit">
                <img src="@/assets/images/template/mart_success.png"/>
                <span>{{$t('success.congratulation')}}，{{$route.query.Type == 1?$t('success.marketOpening'):$route.query.MsgId == 1702?$t('success.pendingModify'):$t('trade.products.pendingOrder')}}{{$t('success.success')}}！</span>
            </div>
            <div class="sucList">
                <ul>
                    <li><p>{{$route.query.Type == 1?$t('success.positionID'):$t('success.pendingID')}}</p><span>{{$route.query.ID}}</span></li>
                    <li><p>{{$route.query.Type == 1?$t('trade.products.tradeProduct'):$t('success.pendingPro')}}</p><span v-if="quote.symbolNotify[util.getShowPrdCode($route.query.Symbol).replace('_CF','')]">{{quote.symbolNotify[util.getShowPrdCode($route.query.Symbol).replace("_CF","")].szShortName}}</span></li>
                    <li><p>{{$t('trade.products.lot')}}</p><span>{{$route.query.RequestVolume}}</span></li>
                    <li v-if="$route.query.Type == 2 || $route.query.Type == 4"><p>{{$t('success.pendingType')}}</p><span>{{$route.query.Type == 2?$t('trade.products.limitPrice'):$t('trade.products.justLoss')}}</span></li>
                    <li><p>{{$route.query.Type == 1?$t('success.openingPrice'):$t('success.pendingPrice')}}</p><span>{{Number($route.query.RequestPrice).toFixed(marketInfo.symbolData.digits)}}</span></li>
                    <li><p>{{$route.query.Type == 1?$t('success.openingDirection'):$t('success.pendingDirection')}}</p><span>{{$route.query.Direction == 1?$t('trade.products.buy'):$t('trade.products.sell')}}</span></li>
                    <li v-if="$route.query.StopLoss != 0"><p>{{$t('trade.products.stopLoss')}}</p><span>{{Number($route.query.StopLoss).toFixed(marketInfo.symbolData.digits)}}<span class="inline" v-if="$route.query.setStopLossTip">(${{$route.query.setStopLossTip}})</span></span></li>
                    <li v-else><p>{{$t('trade.products.stopLoss')}}</p><span>{{$t('trade.products.notSet')}}</span></li>
                    <li v-if="$route.query.TakeProfit != 0"><p>{{$t('trade.products.stopProfit')}}</p><span>{{Number($route.query.TakeProfit).toFixed(marketInfo.symbolData.digits)}}<span class="inline" v-if="$route.query.setStopProfitTip">(${{$route.query.setStopProfitTip}})</span></span></li>
                    <li v-else><p>{{$t('trade.products.stopProfit')}}</p><span>{{$t('trade.products.notSet')}}</span></li>
                    <li v-if="$route.query.StopLoss != 0 || $route.query.TakeProfit != 0"><p>{{$t('trade.products.expectedProfitLoss')}}($)</p><span><i class="rise">{{lossAndProfit.stopProfit > 0 ?'+':''}}{{lossAndProfit.stopProfit}}</i><em>/</em><i class="fall">{{lossAndProfit.stopLoss > 0 ?'+':''}}{{lossAndProfit.stopLoss}}</i></span></li>
                    <li v-if="$route.query.Type != 1"><p>{{$t('trade.products.validityPeriod')}}</p><span>{{$route.query.ExpireType==1?$t('trade.products.day'):$t('trade.products.week')}}</span></li>
                </ul>
            </div>
            <div class="sucBtn"><span @click="goTrade">{{$t('success.viewRecord')}}</span><span @click="goHome">{{$t('success.startTrading')}}</span></div>
        </div>

    </div>
</template>
<script>
    require('@/assets/css/sucOrdered.css');
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import TradeUtil from '@/utils/tradeUtil'
    export default {
        name: "SucOrdered",
        computed: {
            ...mapState(['quote','symbolInfo']),
            marketInfo: {
                get() {
                    let symbolData = {};
                    let tick = {};
                    if (this.quote.symbolNotify && this.quote.symbolNotify[Util.getShowPrdCode(this.$route.query.Symbol).replace("_CF","")]){
                        const code = this.quote.symbolNotify[Util.getShowPrdCode(this.$route.query.Symbol).replace("_CF","")].uiCodeID;
                        if (code && this.quote.notify[code]) {
                            const source = this.quote.notify[code].uiSourceCode;
                            if (this.symbolInfo.codeMap[source]) symbolData = this.symbolInfo.codeMap[source];
                        }
                        if (code && this.quote.codeTickMap && this.quote.codeTickMap[code]) tick = this.quote.codeTickMap[code];
                    }
                    return {
                        symbolData: symbolData,
                        tick: tick
                    };
                }
            },
            //预期盈亏
            lossAndProfit: {
                get() {
                    let loss = null, profit = null;
                    if (this.marketInfo.tick && this.$route.query.StopLoss != 0 && this.$route.query.TakeProfit != 0)
                        if (this.$route.query.Direction == 1) {//买
                            if (this.$route.query.Type == 1){
                                loss = TradeUtil.changeCurrency(Util.accSub(this.$route.query.StopLoss, this.marketInfo.tick.bid), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                                profit = TradeUtil.changeCurrency(Util.accSub(this.$route.query.TakeProfit, this.marketInfo.tick.bid), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                            }else if(this.$route.query.Type == 2 || this.$route.query.Type == 4){
                                loss = TradeUtil.changeCurrency(Util.accSub(this.$route.query.StopLoss, this.$route.query.RequestPrice), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                                profit = TradeUtil.changeCurrency(Util.accSub(this.$route.query.TakeProfit, this.$route.query.RequestPrice), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                            }
                        }else{//卖
                            if (this.$route.query.Type == 1){
                                loss = TradeUtil.changeCurrency(Util.accSub(this.marketInfo.tick.ask,this.$route.query.StopLoss), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                                profit = TradeUtil.changeCurrency(Util.accSub(this.marketInfo.tick.ask,this.$route.query.TakeProfit), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                            }else if(this.$route.query.Type == 2 || this.$route.query.Type == 4){
                                loss = TradeUtil.changeCurrency(Util.accSub(this.$route.query.RequestPrice,this.$route.query.StopLoss), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                                profit = TradeUtil.changeCurrency(Util.accSub(this.$route.query.RequestPrice,this.$route.query.TakeProfit), this.marketInfo.tick.ask, this.marketInfo.tick.bid, this.$route.query.RequestVolume, this.marketInfo.symbolData, this.quote.symbolTickMap, this.$route.query.Direction);
                            }
                        }
                    return {
                        stopLoss:Number(loss).toFixed(2),
                        stopProfit:Number(profit).toFixed(2)
                    }
                }
            }
        },
        beforeCreate() {
            if (this.$cookie.get('orderSuc') == 'suc') {
                //成功页的跳转
                this.$cookie.remove('orderSuc');//删除cookie
            }else{
                //非正常访问
                alert(this.$t('success.pageExpired'));
                this.$router.replace({path:'/home'});
            }
        },
        data(){
            return {
                util:Util,
                tradeUtil:TradeUtil,
            }
        },
        methods:{
            back() {
                this.$router.push({path: '/home'})
            },
            goHome(){
                this.$bus.$emit('loading', false);
                this.$router.replace({path: '/home'})
            },
            goTrade(){
                this.$bus.$emit('loading', false);
                this.$router.replace({path:'/home/trade',query:{type:this.$route.query.Type == 1?0:1}})
            },
        },
        mounted(){
            this.$bus.$emit('loading', true);
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
        },
        activated(){
            this.$bus.$emit('loading', true);
        },
    }
</script>
